<template>
  <form @submit.prevent="setStatusAndSubmit">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/students-marine-practice`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование данных</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">

      <div class="card">
        <div class="card-header">
          <h6>Личные данные</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  ИИН
                </label>
                <div class="col-md-9">
                  {{ marinePractice.student.iin }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Ф.И.О.
                </label>
                <div class="col-md-9">
                  {{ marinePractice.student.lastname }} {{ marinePractice.student.firstname }}
                  {{ marinePractice.student.patronymic }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div v-for="(item, index) in marinePractice.practiceItems" :key="item.practiceType">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <input type="checkbox"
                     class="me-3"
                     :disabled="isDisabled()"
                     v-model="item.activated"/>

              <h6 style="cursor: pointer"
                  @click="onChangeName(item)">
                {{ MarinePracticeTypeEnum[item.practiceType].nameRu }}
              </h6>
            </div>
          </div>
          <div class="card-body" v-if="item.activated">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="isStudying" class="form-label col-md-3">
                  Обучается
                </label>
                <div class="col-md-9">
                  <select v-model="item.studying"
                          :disabled="isDisabled()"
                          id="isStudying"
                          class="form-select"
                          required>
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="numberOfDays" class="form-label col-md-3">
                  Количество дней
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="numberOfDays" type="number" :min="0" :step="1"
                         :disabled="isDisabled()"
                         v-model="item.numberOfDays"
                         required>
                </div>
              </div>
            </div>

            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="dailyExpenses" class="form-label col-md-3">
                  Суточные расходы
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="dailyExpenses" type="number" :min="0" :step="0.01"
                         v-model="item.dailyExpenses"
                         :disabled="isDisabled()"
                         v-on:change="onChange(item)"
                         required>
                </div>
              </div>
            </div>

            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="accommodationExpenses" class="form-label col-md-3">
                  Расходы на проживание
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="accommodationExpenses" type="number" :min="0" :step="0.01"
                         v-model="item.accommodationExpenses"
                         :disabled="isDisabled()"
                         v-on:change="onChange(item)"
                         required>
                </div>
              </div>
            </div>

            <div class="row col-md-9" v-if="item.practiceType === MarinePracticeTypeEnum.SAFETY.code">
              <div class="el-input-group">
                <label for="additionalExpenses" class="form-label col-md-3">
                  Дополнительные расходы
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="additionalExpenses" type="number" :min="0" :step="0.01"
                         v-model="item.additionalExpenses"
                         :disabled="isDisabled()"
                         v-on:change="onChange(item)"
                         required>
                </div>
              </div>
            </div>

            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="totalAmount" class="form-label col-md-3">
                  Затраченная сумма
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="totalAmount" type="number" :min="0" :step="0.01"
                         v-model="item.totalAmount"
                         :disabled="isDisabled()"
                         v-on:change="onChange(item)"
                         required>
                </div>
              </div>
            </div>

            <!-- Подтверждающий документ -->
            <div class="row col-md-9">
              <div class="el-input-group">
                <label for="fileUpload{{index}}" class="form-label col-md-3">
                  Подтверждающий документ (PDF)
                </label>
                <div class="col-md-9" v-if="item.file">
                  <a href="javascript:void(0)" @click="downloadFile(item.file)">
                    {{ item.file.name }}
                  </a>

                  <b-button variant="danger"
                            class="btn-sm"
                            style="margin-left: 20px"
                            v-if="canRemoveFile()"
                            @click="onClickRemoveFile(item)">
                    Удалить
                  </b-button>
                </div>
                <div class="col-md-9" v-if="!item.file">
                  <input type="file" id="fileUpload{{index}}"
                         accept=".pdf" class="form-control"
                         :disabled="isDisabled()"
                         @change="handleFileUpload(item, $event)"
                         required/>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer" v-if="item.activated">
            Общая сумма: {{ item.totalSum || 0}}
          </div>
        </div>

        <br/>
      </div>

      <div class="row col-md-9" v-if="canShowReason()">
        <div class="el-input-group">
          <label for="reason" class="form-label col-md-3">
            Причина отказа
          </label>
          <div class="col-md-9">
          <textarea v-model="marinePractice.reason"
                    :disabled="!canEditReason()"
                    id="reason"
                    style="width: 100%"
                    class="form-label" rows="5"></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer justify-content-end">
      <div
          v-if="hasAccess(universityManagerRoles) && (!marinePractice.status || marinePractice.status === StudentApplicationStatusEnum.SENT_FOR_REVISION)">
        <b-button variant="success"
                  type="submit"
                  v-if="marinePractice.status == null || marinePractice.status === StudentApplicationStatusEnum.SENT_FOR_REVISION"
                  :disabled="!hasAnySelectedPractice()"
                  @click="setStatus(StudentApplicationStatusEnum.SENT_FOR_APPROVAL)">
          Отправить на согласование
        </b-button>
      </div>

      <div v-if="hasAccess(managerRoles) && marinePractice.status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL">
        <b-button variant="outline-info" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.SENT_FOR_REVISION)">
          Отправить на доработку
        </b-button>

        <b-button variant="success" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.APPROVED)">
          Принять
        </b-button>

        <b-button variant="danger" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.REJECTED)">
          Отказать
        </b-button>
      </div>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import studentMarinePracticeService from "@/services/studentMarinePracticeService";
import authService from "@/services/authService";
import {StudentApplicationStatusEnum} from "@/enum/StudentApplicationStatusEnum";
import fileService from "@/services/fileService";
import {MarinePracticeTypeEnum} from "@/enum/MarinePracticeTypeEnum";

export default {
  components: {
    VueLoading
  },
  computed: {
    MarinePracticeTypeEnum() {
      return MarinePracticeTypeEnum
    },
    StudentApplicationStatusEnum() {
      return StudentApplicationStatusEnum
    },
    studentUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      marinePractice: {
        uuid: null,
        student: {},
        practiceItems: [],
        status: null,
        reason: null
      },
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
      practices: [
        {
          practiceType: MarinePracticeTypeEnum.SAFETY.code,
          activated: false,
          studying: null,
          numberOfDays: null,
          dailyExpenses: null,
          accommodationExpenses: null,
          additionalExpenses: null,
          totalAmount: null,
          totalSum: null,
          fileId: null,
          uploadedFile: null,
          file: null
        },
        {
          practiceType: MarinePracticeTypeEnum.MARITIME.code,
          activated: false,
          studying: null,
          numberOfDays: null,
          dailyExpenses: null,
          accommodationExpenses: null,
          totalAmount: null,
          totalSum: null,
          fileId: null,
          uploadedFile: null,
          file: null
        }
      ]
    };
  },
  methods: {
    init() {
      this.findById(this.studentUuid);
    },
    async findById(studentUuid) {
      this.isLoading = true;
      this.marinePractice = await studentMarinePracticeService.findByStudentUuid(studentUuid);
      this.initDefaultValues();

      await this.loadFileInfo(this.marinePractice);
      this.isLoading = false;
    },
    isValid() {
      return true;
    },
    setStatus(status) {
      this.status = status;
    },
    setStatusAndSubmit(event) {
      if (this.status && this.status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
        if (!this.isValid()) {
          event.preventDefault();
          return;
        }
      }

      this.submitForm();
    },
    async submitForm() {
      try {
        this.isLoading = true;

        if (this.marinePractice && this.marinePractice.practiceItems) {
          for (const item of this.marinePractice.practiceItems) {
            if (!item.fileId && item.uploadedFile) {
              const formData = new FormData();
              formData.append('studentUuid', this.marinePractice.studentUuid);
              formData.append('file', item.uploadedFile);

              item.file = await fileService.uploadFile(formData);
              item.fileId = item.file.uuid;
            }
          }
        }

        this.marinePractice.status = this.status;

        this.marinePractice = await studentMarinePracticeService.save(this.marinePractice);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    handleFileUpload(item, event) {
      const file = event.target.files[0];
      if (file) {
        item.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    hasAccess(...roleGroups) {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    },
    async loadFileInfo(marinePractice) {
      if (marinePractice && marinePractice.practiceItems) {
        for (const item of marinePractice.practiceItems) {
          if (item.fileId) {
            item.file = await fileService.loadFileInfo(item.fileId);
            console.log(item.file);
          }
        }
      }
    },
    async downloadFile(file) {
      await fileService.download(file.uuid, file.name);
    },
    async onClickRemoveFile(practice) {
      const confirmed = await confirm("Вы уверены, что хотите удалить данный файл?");
      if (confirmed) {
        try {
          await fileService.deleteFileById(practice.file.uuid);

          practice.file = null;
          practice.fileId = null;

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    isDisabled() {
      const status = this.marinePractice.status;
      if (status && (status === StudentApplicationStatusEnum.APPROVED || status === StudentApplicationStatusEnum.REJECTED)) {
        return true;
      } else if (this.hasAccess(this.managerRoles)) {
        return true;
      } else if (this.hasAccess(this.universityManagerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
        return false;
      }
      return true;
    },
    canRemoveFile() {
      if (this.hasAccess(this.universityManagerRoles)) {
        const status = this.marinePractice.status;
        if (!status || status === StudentApplicationStatusEnum.SENT_FOR_REVISION) {
          return true;
        }
      }
      return false;
    },
    canShowReason() {
      const status = this.marinePractice.status;
      if (status && status === StudentApplicationStatusEnum.APPROVED) {
        return false;
      }

      if (this.hasAccess(this.universityManagerRoles)) {
        if (!status) {
          return false;
        }

        if (status) {
          if (status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
            return false;
          }
        }
      }

      return true;
    },
    canEditReason() {
      const status = this.marinePractice.status;
      if (this.hasAccess(this.managerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
      }
      return false;
    },
    hasAnySelectedPractice() {
      if (this.marinePractice && this.marinePractice.practiceItems) {
        return this.marinePractice.practiceItems
            .filter(p => p.activated != null && p.activated === true)
            .length > 0;
      }
      return false;
    },
    initDefaultValues() {
      if (this.marinePractice && (!this.marinePractice.practiceItems || this.marinePractice.practiceItems.length === 0)) {
        this.marinePractice.practiceItems = structuredClone(this.practices);
      }
    },
    onChangeName(item) {
      if (this.isDisabled()) {
        return;
      }

      item.activated = !item.activated
    },
    calcTotalSum(item) {
      const dailyExpenses = item.dailyExpenses || 0;
      const accommodationExpenses = item.accommodationExpenses || 0;
      const additionalExpenses = item.additionalExpenses || 0;
      const totalAmount = item.totalAmount || 0;
      return dailyExpenses + accommodationExpenses + additionalExpenses + totalAmount;
    },
    onChange(item) {
      item.totalSum = this.calcTotalSum(item);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.btn-mr {
  margin-right: 15px;
}
</style>
